import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPageComponent } from './pages/main-pages/user/main-page/main-page.component';
import { ProfilePageComponent } from './pages/main-pages/user/profile-page/profile-page.component';
import { LoginPageComponent } from './pages/registration-pages/login-page/login-page.component';
import { RegistrationPageComponent } from './pages/registration-pages/registration-page/registration-page.component';
import {
  ForgotPasswordPageComponent,
} from './pages/registration-pages/forgot-password-page/forgot-password-page.component';
import { VideoPageComponent } from './pages/main-pages/communication/video-page/video-page.component';
import { StreamChatComponent } from './pages/main-pages/communication/stream-chat/stream-chat.component';
import { AuthGuard } from './shared/guards/auth.guard';
import {
  CompanyDashboardPageComponent,
} from './pages/main-pages/company/company-dashboard-page/company-dashboard-page.component';
import { JobsPageComponent } from './pages/main-pages/company/jobs-page/jobs-page.component';
import { JobsDetailsComponent } from './pages/main-pages/company/jobs-details/jobs-details.component';
import { AdminDashboardPageComponent } from './pages/main-pages/admin-dashboard-page/admin-dashboard-page.component';
import { JobDescriptionComponent } from './pages/main-pages/user/jobs-description/jobs-description.component';
import { JobOfferCreateComponent } from './pages/main-pages/company/create-job-offer-page/create-job-offer.component';
import {
  ApplicationsOverviewPageComponent,
} from './pages/main-pages/user/applications-overview-page/applications-overview-page.component';
import { SettingsPageComponent } from './pages/main-pages/user/settings-page/settings-page.component';
import {
  ApplicationOverviewPageComponent
} from "./pages/main-pages/company/application-overview-page/application-overview-page.component";
import {AgencyDashboardPageComponent} from "./pages/main-pages/agency-dashboard-page/agency-dashboard-page.component";
import {
  CandidateApplicationOverviewPageComponent
} from "./pages/main-pages/user/candidate-overview-page/candidate-overview-page.component";
import {DashboardPageComponent} from "./pages/main-pages/admin-dashboard-page/dashboard-page/dashboard-page.component";
import {UserPageComponent} from "./pages/main-pages/admin-dashboard-page/user-page/user-page.component";
import {CompanyPageComponent} from "./pages/main-pages/admin-dashboard-page/company-page/company-page.component";
import {PrivacyComponent} from "./pages/main-pages/privacy/privacy.component";
import { PricingPageComponent } from './pages/registration-pages/pricing-page/pricing-page.component';
import { AccountDeletionComponent } from './pages/main-pages/account-deletion/account-deletion.component';



export const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'applications-overview/:id', component: ApplicationsOverviewPageComponent, canActivate: [ AuthGuard ] },
  { path: 'candidate-overview/:id', component: CandidateApplicationOverviewPageComponent, canActivate: [ AuthGuard ] },
  { path: 'register', component: RegistrationPageComponent  },
  { path: 'main/:id', component: MainPageComponent, canActivate: [ AuthGuard ] },
  { path: 'profile/:id', component: ProfilePageComponent, canActivate: [ AuthGuard ] },
  { path: 'create-job-offer/:companyId', component: JobOfferCreateComponent, canActivate: [ AuthGuard ] },
  { path: 'job-description/:jobId', component: JobDescriptionComponent, canActivate: [ AuthGuard ]  },
  { path: 'application-overview/:applicationId', component: ApplicationOverviewPageComponent, canActivate: [ AuthGuard ]  },
  { path: 'companyDashboard/:id', component: CompanyDashboardPageComponent, canActivate: [ AuthGuard ] },
  { path: 'adminDashboard', component: AdminDashboardPageComponent, canActivate: [ AuthGuard ] },
  { path: 'agencyDashboard', component: AgencyDashboardPageComponent },
  { path: 'jobs', component: JobsPageComponent, canActivate: [ AuthGuard ] },
  { path: 'jobs/:id', component: JobsDetailsComponent, canActivate: [ AuthGuard ] },
  { path: 'chat/:id', component: StreamChatComponent, canActivate: [ AuthGuard ] },
  { path: 'video/:id', component: VideoPageComponent },
  { path: 'settings', component: SettingsPageComponent, canActivate: [ AuthGuard ] },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: 'dashboard', component: DashboardPageComponent, title: 'Dashboard' },
  { path: 'users', component: UserPageComponent, title: 'Users' },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'account-deletion', component: AccountDeletionComponent },
  { path: 'pricing/:id', component: PricingPageComponent },
  { path: 'companies', component: CompanyPageComponent, title: 'Companies' },
  {
    path: '**',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'register',
    component: RegistrationPageComponent,
  },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: '**', redirectTo: 'login' },
];

@NgModule( {
  imports: [ RouterModule.forRoot( routes ) ],
  exports: [ RouterModule ],
} )
export class AppRoutingModule {
}
